import styled from "styled-components";

export const StyledJumpToProfileNode = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    background-color: white;
    border-radius: 3px;
    width: 280px;
    height: 45px;
    font-size: 16px;

    box-shadow: 0px 4px 15px rgba(175, 112, 221,0.15),
        inset 0px -1px 0px rgba(175, 112, 221, 0.6);
    border-radius: 5px 0px 5px 5px;
    position: relative;
    transition: box-shadow 0.2s ease-in;

    .nodeBody {
        display: flex;
        width: 100%;
        padding: 0 20px;
        align-items: center;
        justify-content: start;
        gap: 10px;

        .nodeBody > img {
            width: 25px;
            height: 25px;
            margin-right: 10px;
        }
    }

    outline: ${(props) => (props?.$isActive ? "3px solid #af70dd" : "none")};

    &:hover {
        box-shadow: 0px 5px 15px rgba(175, 112, 221, 0.2),
            inset 0px -1px 0px rgba(175, 112, 221, 0.3);

    }

    &:hover {
        .action-btns {
            visibility: visible;
        }
    }

    position: relative;

    .titleContainer {
        display: flex;
        gap: 10px;
        width: 93%;

        span {
            font-family: var(--access-font-family);
            font-weight: 500;
            font-size: 14px;
            color: #af70dd;
            max-width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
    }

    span.messageText {
        color: #af70dd;
        font-family: var(--access-font-family);
        font-weight: 500;
        font-size: 12px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        text-align: left;

        p {
            margin: 0;
            padding: 0;
        }
    }
`;

export const ActionButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    position: absolute;
    top: 0;
    right: -50px;
    border: solid 1px #e8e9ef;
    background-color: #ffffff;
    box-shadow: 0 2px 20px 0 rgba(232, 233, 239, 0.5);
    transition: all 1s ease;
    visibility: hidden;

    img {
        cursor: pointer;
    }
`;
